export const microBrand = {
    product: 'qportal',
    accentMark: '#141414',
    accentMarkIdle: '#FFBC00',
    markIdleOpacity: 0,
    twoToneIndicator: true,
    tint: '#FFF3D1',
    hover: '#FFF4D6',
    focus: '#141414',
    text: '#161C24',
    destructive: '#B71D18',
    destructiveSoft: '#FFE4DE',
    destructiveStrong: '#7A100D',
    onDestructive: '#FFFFFF',
    sparkColors: ['#FFBC00', '#141414'],
    segmentStretch: 0,
    ambientTop: '#FFFFFF',
    ambientBottom: '#FFF7E0'
};
